import React from 'react'
import BlogHero from './components/BlogHero'
import Blogs from './components/Blogs'

const Blog = () => {
  return (
    <div>
         <div class="mt-5">
          <Blogs/>
       </div>
       
    </div>
  )
}

export default Blog
